import { Injectable } from '@angular/core';

import type { HomeTab } from './home-tabs/home-tabs.component';
import type { HomeMetricKey } from './home-summary.types';

export interface RequestsHomeViewState {
  tab: HomeTab;
  tileKey: HomeMetricKey | null;
}

/** In-memory My/All-requests tab + tile state so back navigation restores the view the user left.
 *  Session-only, same contract as GridStateService: refresh starts clean, logout clears it. */
@Injectable({ providedIn: 'root' })
export class RequestsHomeStateService {
  private state: RequestsHomeViewState | null = null;

  save(state: RequestsHomeViewState): void {
    this.state = { ...state };
  }

  get(): RequestsHomeViewState | null {
    return this.state ? { ...this.state } : null;
  }

  clear(): void {
    this.state = null;
  }
}
